export const EventAccessType = {
  BRANCH_ONLY: 'BRANCH_ONLY',
  COUNTRYWIDE: 'COUNTRYWIDE',
  GLOBAL: 'GLOBAL',
};

export const eventAccessTypes = [
  EventAccessType.BRANCH_ONLY,
  EventAccessType.COUNTRYWIDE,
  EventAccessType.GLOBAL,
];
